export enum StartOptions {
  plate = 'Placa',
  policeNumber = 'Número de póliza',
  idType = 'Tipo de ID'
}
